import {
	apiRequest
} from '../api.js'

//获取推荐单位
export function getRecomCompany(config) {
	config.method = 'post'
	config.url = '/proapi/v1/application/get-recommend-company'
	apiRequest(config)
}

// 获取省份地市
export function getLocation(config) {
	config.method = 'post'
	config.url = '/appapi/login/get-province'
	apiRequest(config)
}

export function getCompanyList(config) {

	config.method = 'post'
	config.url = '/proapi/login/get-company-list'
	apiRequest(config)

}

// 获取城市
export function getCity(config) {
	config.method = 'post'
	config.url = '/appapi/login/get-city'
	apiRequest(config)
}

// 获取区域
export function getArea(config) {
	config.method = 'post'
	config.url = '/appapi/login/get-area'
	apiRequest(config)
}

// 登录
export function userLogin(config) {
	config.method = 'post'
	config.url = '/proapi/login/login'
	apiRequest(config)
}

// 会员门户的注册
export function userRegister(config) {
	config.method = 'post'
	config.url = '/proapi/login/register'
	apiRequest(config)
}

//生成最大的登录账号-山东改河北 /proapi/login/produce-max
export function produceMax(config) {
	config.method = 'get'
	config.url = '/proapi/login/produce_login_account'
	apiRequest(config)
}



export function getCompanyNames(config) {

	config.method = 'post'
	config.url = '/proapi/login/get-company'
	apiRequest(config)

}

export function getTaxNumber(config) {

	config.method = 'post'
	config.url = '/proapi/login/get-tax-num'
	apiRequest(config)

}


// 修改密码
export function changePassword(config) {
	config.method = 'post'
	config.url = '/proapi/v1/project/update-pwd'
	apiRequest(config)
}

// 忘记密码
export function forgetPassword(config) {
	config.method = 'post'
	config.url = '/proapi/login/update-pwd'
	apiRequest(config)
}

//发码平台发送验证码
export function sendSms(config) {
	config.method = 'post'
	config.url = '/proapi/login/send-sms'
	apiRequest(config)
}

// 退出登录
export function loginout(config) {
	config.method = 'post'
	config.url = '/proapi/login/logout'
	apiRequest(config)
}

/* 获取企业前缀*/
export function getCompony(config) {
	config.method = 'post'
	config.url = '/appapi/login/get-company'
	apiRequest(config)
}
